export default basePath => ({
  ativar: { method: 'PUT', url: `${basePath}/ativacao/{id}/true` },
  atualizar: { method: 'PUT', url: `${basePath}` },
  gravar: { method: 'POST', url: `${basePath}` },
  inativar: { method: 'PUT', url: `${basePath}/ativacao/{id}/false` },
  listar: { method: 'GET', url: `${basePath}?tamanhoPagina={size}&numeroPagina={page}` },
  listarAtivos: { method: 'GET', url: `${basePath}?tamanhoPagina=10&numeroPagina=1&nome={nome}&indAtivo=true` },
});



// WEBPACK FOOTER //
// ./src/common/resources/generic-resource.js